import { Component, OnInit, ViewChild, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import gql from 'graphql-tag';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { SecurityService } from 'src/app/shared/services/security.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { v4 as uuidv4 } from 'uuid';
import { ConsoleService } from 'src/app/shared/services/console.service';

@Component({
  selector: 'app-modal-seleccionar-cliente-tipos',
  templateUrl: './modal-seleccionar-cliente-tipos.component.html',
  styleUrls: ['./modal-seleccionar-cliente-tipos.component.scss'],
  providers: [SecurityService],
})
export class ModalSeleccionarClienteTiposComponent implements OnInit {

  // Modales
  @ViewChild('seleccionarClientesTipos', { static: true })
  seleccionarClientesTiposModal: ModalDirective;

  mode: 'SEARCH' | 'VIEW_SELECTED' = 'SEARCH'

  // Data
  data: any = []
  selectedData: any = []
  busquedaIniciada: boolean = false

  // Output
  @Output() onSelectMultiple: EventEmitter<any> = new EventEmitter<any>();

  // Input
  @Input() origen: String = null

  // Utils
  private log: any

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private clog: ConsoleService
  ) {
    this.log = this.clog.log('MODAL-SELECCION-TIPO-CLIENTE')
  }

  ngOnInit() {
    this.buscar()
  }


  /********* SEARCH *********/
  buscar() {
    // // limpiar datos antes de desplegar
    // this.reset(1)

    const self = this
    this.gqlclient.query(
      {
        query: gql`
          query {
            tipo_cliente{
              obtenerTodos
              {
                respuesta{
                  registros
                  {
                    codigo
                    descripcion
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        // const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(
        //   respuesta.data.cliente_proveedor.obtenerSegunFiltro
        // );
        // if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        // } else {
        //   alert(notificacion.mensajes[0].texto);
        // }

        const { mensajes, respuesta } = response.data.tipo_cliente.obtenerTodos
        self.data = respuesta.registros
        self.data.map(p => { p.checked = false })
        self.data.forEach(element => {
          delete element.__typename
        });
        self.busquedaIniciada = true
      }
    );
  }
  /********* SEARCH *********/

  /********* SHOW/HIDE *********/
  show(cleanData: Boolean = false) {
    if (cleanData) this.reset()
    this.mode = 'SEARCH'
    this.seleccionarClientesTiposModal.show();
  }

  showSelected() {
    this.mode = 'VIEW_SELECTED'
    this.seleccionarClientesTiposModal.show();
  }

  hide() {
    this.seleccionarClientesTiposModal.hide();
  }
  /********* SHOW/HIDE *********/


  /********* OPERATIONS *********/
  reset() {
    this.data.map(p => { p.checked = false })
  }

  checkAllChange({ checked }){
    // emitir evento
    let info =  this.data.forEach(p =>{ p.checked = checked})
    let _data = this.data.filter(p => p.checked === true)

    this.selectedData = _data

    this.onSelectMultiple.emit({
      data: _data,
      origen: this.origen
    })

    if (this.mode === 'VIEW_SELECTED' && this.selectedData.length === 0)
      this.hide()
  }

  checkTipo(tipo: any) {
    const selected = this.data.filter(p => p.codigo === tipo.codigo)[0]
    selected.checked = !selected.checked

    // emitir evento
    let _data = [...this.data].filter(p => p.checked)
    // this.log({
    //   data: _data,
    //   origen: this.origen
    // })

    this.selectedData = _data
    this.onSelectMultiple.emit({
      data: _data,
      origen: this.origen
    })

    if (this.mode === 'VIEW_SELECTED' && this.selectedData.length === 0)
      this.hide()
  }

  selectData(tipo: any) {
  }
  /********* OPERATIONS *********/

}
